export const getSortedComponents = (children) => {
    var _a;
    // @ts-ignore
    window.children = children;
    return (_a = (Array.isArray(children) ? children : [children])) === null || _a === void 0 ? void 0 : _a.reduce((init, cur) => {
        var _a, _b, _c, _d;
        // @ts-ignore
        const lowerCase = (((_a = cur === null || cur === void 0 ? void 0 : cur.type) === null || _a === void 0 ? void 0 : _a.componentName) || ((_c = (_b = cur === null || cur === void 0 ? void 0 : cur.type) === null || _b === void 0 ? void 0 : _b.render) === null || _c === void 0 ? void 0 : _c.componentName) || ((_d = cur === null || cur === void 0 ? void 0 : cur.type) === null || _d === void 0 ? void 0 : _d.name) || '').toLocaleLowerCase();
        if (lowerCase.includes('resourcepanel')) {
            init['resourcePanel'].push(cur);
        }
        else if (lowerCase.includes('toolbar')) {
            init['toolbar'].push(cur);
        }
        else if (lowerCase === null || lowerCase === void 0 ? void 0 : lowerCase.includes('canvas')) {
            init['canvas'].push(cur);
        }
        else if (lowerCase === null || lowerCase === void 0 ? void 0 : lowerCase.includes('configpanel')) {
            init['configPanel'].push(cur);
        }
        else if (lowerCase === null || lowerCase === void 0 ? void 0 : lowerCase.includes('consolepanel')) {
            init['consolePanel'].push(cur);
        }
        return init;
    }, {
        resourcePanel: [],
        toolbar: [],
        canvas: [],
        configPanel: [],
        consolePanel: []
    });
};
//# sourceMappingURL=component.js.map